import React from "react";
import { useEffect } from "react";
import { AuthRestartButton } from "../misc/restart-button.component";
import { removeNonNumericCharacters } from "../../../utils/utils";
import { AuthPaymentContainer } from "../misc/auth-payment-container.component";
import { AuthContinue } from "../misc/auth-continue.component";
import { ReviewDisplayField } from "../misc/review-display-field.component";
import payoffMessage from "../misc/payoff-message.component";
import { StandardAchDisclosure } from "../misc/disclosures";
import Show from "../../../utils/show.component";
import { generateLoanDescription, formatLastFour } from "../misc/messaging-utils";
import moment from "moment";

export const AuthExternalAchReview = (props) => {
  const advance = (externalAchFormValues) => {
    window.scrollTo(0, 0);

    let paymentDetails = Object.assign({}, externalAchFormValues);
    paymentDetails.Amount = removeNonNumericCharacters(paymentDetails.Amount);

    const isScheduledPayment = moment(paymentDetails.ScheduledPaymentDate).isAfter(moment());

    if (isScheduledPayment) {
      paymentDetails.ScheduledPaymentSetup = {
        PaymentDate: paymentDetails.ScheduledPaymentDate,
      };
    }

    // Remove to avoid confusion
    paymentDetails.ScheduledPaymentDate = undefined;

    props.callAuthSubmitAchPayment(paymentDetails);
  };

  useEffect(() => {
    // If the payment response has this property, that means there were no errors
    // submitting the payment and the paymentResponse property has been set
    if (props.paymentResponse.hasOwnProperty("AmountDue")) {
      props.setProcessStep(3);
    }
  }, [props.paymentResponse]);

  return (
    <AuthPaymentContainer title="Review & Submit">
      <div className="text-centered bold f20">
        {`${generateLoanDescription(props.selectedLoan, true)}`}
      </div>
      <div className="my-4 divider"></div>
      <div>
        <Show condition={props.scheduledPaymentDate}>
          <ReviewDisplayField title={"Payment Date"} value={moment(props.scheduledPaymentDate).format("MM/DD/YYYY")} />
        </Show>
        <ReviewDisplayField title={"Payment Applied Date"} value={props.paymentAppliedDate} />
        <ReviewDisplayField
          title={"Payment Account"}
          value={"Ending in " + props.paymentAccount}
          valueClassNames={"minwidth-fit"}
        />
        <ReviewDisplayField title={"Payment Amount"} value={props.paymentAmount} />
      </div>
      <Show condition={props.isPayoff}>{payoffMessage(props.paymentAppliedDate)}</Show>
      {StandardAchDisclosure()}
      <AuthContinue
        type="button"
        title={props.isPayoff ? "Pay Off My Loan" : "Submit Payment"}
        onClickFunction={() => advance(props.externalAchFormValues)}
      />
      <AuthRestartButton backToLoans={props.backToLoans} />
    </AuthPaymentContainer>
  );
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/review/auth-bank-review-fields.component.js